/**
 * «Повідомити про проблему» (UX-51): стан відкритої форми. Модуль лежить у головному чанку й малий:
 * форма (`ReportDialog.tsx`) і збирання тексту звернення (`report-text.ts`) завантажуються лише при
 * відкритті, а кнопки на станах помилок і в меню лише викликають `openReport`.
 */
import { useSyncExternalStore } from 'react';
import { cleanCode, cleanTraceId } from './classify.ts';
import { lastError } from './diagnostics.ts';

/** Звідки відкрили форму: код помилки на екрані (якщо був) і `traceId`. */
export interface ReportRequest {
  code: string | null;
  traceId: string | null;
}

let request: ReportRequest | null = null;
const listeners = new Set<() => void>();

const emit = () => {
  for (const listener of listeners) listener();
};

/**
 * Відкрити форму. Без аргументів (меню, палітра) береться остання помилка, яку бачила людина, —
 * вона вже в технічних даних, тож у формі лише підказка про код.
 */
export function openReport(from: Partial<ReportRequest> = {}): void {
  const last = from.code === undefined ? lastError() : null;
  request = {
    code: cleanCode(from.code ?? last?.code ?? null),
    traceId: cleanTraceId(from.traceId ?? last?.traceId ?? null),
  };
  emit();
}

export function closeReport(): void {
  if (request === null) return;
  request = null;
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useReportRequest(): ReportRequest | null {
  return useSyncExternalStore(
    subscribe,
    () => request,
    () => null,
  );
}
